module.exports = __webpack_public_path__ + "assets/images/0c34360800eb064b0bd3ae403d97c468.png";